var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v("Ekstra Chatbot Satın Al"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "subtitle" }, [_vm._v("Session Seçiniz")]),
        _vm._v(" "),
        _c("div", { staticClass: "suggestion-sessions" }, [
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000
                },
              },
            },
            [_vm._v("\n                1000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 5000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 5000
                },
              },
            },
            [_vm._v("\n                5000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 10000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 10000
                },
              },
            },
            [_vm._v("\n                10000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 20000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 20000
                },
              },
            },
            [_vm._v("\n                20000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 50000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 50000
                },
              },
            },
            [_vm._v("\n                50000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 100000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 100000
                },
              },
            },
            [_vm._v("\n                100000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 250000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 250000
                },
              },
            },
            [_vm._v("\n                250000\n            ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "suggestion-item",
              class: [_vm.sessionCount == 1000000 && "selected"],
              on: {
                click: function ($event) {
                  _vm.sessionCount = 1000000
                },
              },
            },
            [_vm._v("\n                1000000\n            ")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "result-chatbot" },
          [
            _c(
              "div",
              { staticClass: "session-count" },
              [
                _c("a-input-number", {
                  attrs: { min: 1, max: 10000000 },
                  model: {
                    value: _vm.sessionCount,
                    callback: function ($$v) {
                      _vm.sessionCount = $$v
                    },
                    expression: "sessionCount",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "material-icons" }, [
              _vm._v("arrow_forward"),
            ]),
            _vm._v(" "),
            _c("MoneyFormatter", {
              attrs: {
                price: _vm.totalPrice,
                className: _vm.total - _vm.price,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "footer" }, [
          _c("div", { staticClass: "subbutton", on: { click: _vm.confirm } }, [
            _vm._v("Buy now"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cancel-b", on: { click: _vm.cancel } }, [
            _vm._v("Cancel"),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }